import React from "react";
import BlogThirtyFour from "../component/BlogThirtyFour";

function BlogThirtyFourContainer() {
  return <BlogThirtyFour />;
}
export default BlogThirtyFourContainer;
